<template>
    <v-tooltip
        v-model="showHelp"
        left
        close-delay="1000"
    >
        <template v-slot:activator="{ on, attrs }">
        <div 
            v-bind="attrs"
            v-on="on"
            class="widget-archive-proposal d-flex justify-center align-center">
                <v-icon
                @click="dialogRander = !dialogRander"
                large
                :color="$mainColor"
                >
                mdi-archive-arrow-down
                </v-icon>
                <v-dialog
                v-model="dialog"
                persistent
                max-width="650"
                >
                <v-card>
                    <v-card-title class="headline">
                        {{$t('WidgetsArchive.confirm_action')}}
                    </v-card-title>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        :loading="loaded"
                        color="green darken-1"
                        text 
                        @click="addArchiveProposal(dataProposal)"
                    >
                        {{$t('confirm')}}
                    </v-btn>
                    <!--v-btn
                        color="green darken-1"
                        text
                        @click="dialogRander = dialog = false"
                    >
                        {{$t('go_out')}}
                    </v-btn-->
                    </v-card-actions>
                </v-card>
                </v-dialog>
                <v-dialog 
                persistent
                v-model="dialogRander"
                >
                    <widget-archive-proposal-layouts
                    v-if="GETTERS_ARCHIVE_PROPOSAL.length !== 0"
                    @name-author="nameAuthor = $event"
                    @close="dialog = true, textMessageCheck = $event.text, dataProposal = $event.proposal"
                    @add="dialog = true, textMessageCheck = $event.text + ` ${nameAuthor}`, dataProposal = $event.proposal"
                    />
                    <v-progress-linear
                        v-else
                        indeterminate
                        :color="$mainColor"
                    ></v-progress-linear>
                </v-dialog>
            </div>
        </template>
        <span>{{$t('WidgetsArchive.main_text')}}</span>
    </v-tooltip>
    
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import WidgetArchiveProposalLayouts from '../../layouts/WidgetArchiveProposal-Layouts'

export default {
    name: 'ArchiveFileWidget',
    props: {
        name: String
    },
    data() {
        return {
            showHelp: true,
            nameAuthor: '',
            dataProposal: null,
            textMessageCheck: '',
            dialog: false,
            dialogRander: true,
            search: '',
            loaded: false
        }
    },
    components: {
        WidgetArchiveProposalLayouts
    },
    computed: {
        ...mapGetters(['GETTERS_ARCHIVE_PROPOSAL'])
    },
    mounted() {
        this.GET_ARCHIVE_PROPOSAL()
    },
    methods: {
        ...mapActions(['GET_ARCHIVE_PROPOSAL', 'ADD_ARCHIVE_PROPOSAL']),
        addArchiveProposal(data) {

            this.loaded = true

            this.ADD_ARCHIVE_PROPOSAL(data)
            .then(res => {
                this.loaded = false
                if(res) {
                    
                    this.dataProposal.proposals.length !== 0 ?
                    this.$messageHelper('Заявки успешно добавлены', 'success', 6000) :
                    this.$messageHelper(this.$t('success'), 'success', 6000)
                    this.$emit('archive-hide')
                    this.dialogRander = false
                }
            }) 
        }
    },
    watch: {
        loaded(val) {
            if (!val) {
                this.dialogRander = this.dialog = false
            }
        }
    }
}
</script>
<style scoped>
.widget-archive-proposal {
    max-width: 700px;
    width: 100%;
    background: white;
    width: 60px;
    height: 60px;
    border-radius: 40%;
    position: fixed;
    bottom: 180px;
    right: 25px;
    cursor: pointer;
    z-index: 10;
    box-shadow: 2px 2px 6px rgba(0,0,0,.08);
}

</style>